import { Outlet } from "react-router-dom";
import { WhatsAppButton } from "./WhatsAppButton";
import { StickyHeader } from "./StickyHeader";
import { ExitIntentPopup } from "./ExitIntentPopup";
import { FloatingBottomBar } from "./FloatingBottomBar";

export function Layout() {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <StickyHeader />
      <main>
        <Outlet />
      </main>
      <WhatsAppButton />
      <ExitIntentPopup />
      <FloatingBottomBar />
    </div>
  );
}
